import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { updateUiSlice, selectUiState } from '../../redux/slices/ui';
import { bookingEngineRoutes } from '../../../shared/data';
import { getBrandThemeColors } from '../../../shared/brandThemeColors';

const LayoutManager = props => {
  const dispatch = useDispatch();
  const location = useLocation();
  const brand = useSelector(state => state.brand);
  const { isBookingEngine } = useSelector(selectUiState);

  const determineLayout = () => {
    const pathName = location.pathname;
    let isBookingEngine = false;
    bookingEngineRoutes.forEach(route => {
      if (brand?.cms_version === 1 && pathName.startsWith(route))
        isBookingEngine = true;
    });
    if (!isBookingEngine) document.body.classList.add('v2-modern');
    else document.body.classList.remove('v2-modern');
    dispatch(updateUiSlice({ isBookingEngine }));
  };

  useEffect(
    () => {
      determineLayout();
    },
    [location.pathname, brand?.cms_version]
  );

  useEffect(() => {
    if (!brand?.brand_info) return;
    const colors = getBrandThemeColors(brand.brand_info);
    if (colors.color_primary && colors.color_primary_text) {
      document.documentElement.style.setProperty(
        '--primary-cta-color',
        colors.color_primary
      );
      document.documentElement.style.setProperty(
        '--primary-cta-text-color',
        colors.color_primary_text
      );
    }

    if (colors.color_secondary && colors.color_secondary_text) {
      document.documentElement.style.setProperty(
        '--secondary-cta-color',
        colors.color_secondary
      );
      document.documentElement.style.setProperty(
        '--secondary-cta-text-color',
        colors.color_secondary_text
      );
    }

    if (colors.color_decorative_icon) {
      document.documentElement.style.setProperty(
        '--decorative-icon-color',
        colors.color_decorative_icon
      );
    }
  }, [brand]);

  return <>{props.children}</>;
};

export default LayoutManager;
